export default (state = [], action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_NOTIFICATIONS':
      return payload
    case 'DELETE_ALL_NOTIFICATIONS':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}